import { InsightShareCategory } from '@terminal/views/insight-feed/utils/buildInsightShareUrl';
import { handleCopyDrawer } from '@terminal/views/insight-feed/utils/handleCopyDrawer';
import { type RefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UseInsightCopyArgs {
  contentWrapperRef?: RefObject<HTMLDivElement | null>;
  expandAccordions?: (expand: boolean) => void;
  insightId?: string;
  insightUrl?: string;
  insightTitle?: string;
  insightCategory?: InsightShareCategory;
}

export const useInsightCopy = ({
  contentWrapperRef,
  expandAccordions,
  insightId,
  insightUrl,
  insightTitle,
  insightCategory,
}: UseInsightCopyArgs) => {
  const { t } = useTranslation(['widget']);
  const [isCopying, setIsCopying] = useState(false);

  const handleCopyInsight = async () => {
    if (!contentWrapperRef?.current || isCopying) {
      return;
    }

    setIsCopying(true);
    try {
      await handleCopyDrawer({
        contentToCopy: contentWrapperRef.current,
        expandAccordions,
        insightId,
        insightUrl,
        insightLinkLabel: insightUrl
          ? (insightTitle ?? t('widget:insightLink'))
          : undefined,
        insightCategory,
      });
    } finally {
      setIsCopying(false);
    }
  };

  return { isCopying, handleCopyInsight };
};
